import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a40f59c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "roas"
};
const _hoisted_2 = {
  class: "roas-graph"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "1", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  key: 1,
  class: "roas-text gray"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_roas_graph = _resolveComponent("roas-graph");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_roas_graph, {
    values: $options.computedRoasData,
    selected_period: $props.selected_period,
    hovering_index: $props.hovering_index,
    workspace_id: $props.workspace_id,
    seller_id: $props.seller_id,
    hovering_workspace_id: $props.hovering_workspace_id,
    hovering_seller_id: $props.hovering_seller_id
  }, null, 8, ["values", "selected_period", "hovering_index", "workspace_id", "seller_id", "hovering_workspace_id", "hovering_seller_id"]), _createElementVNode("div", {
    class: "dash-line",
    style: _normalizeStyle($options.computedBottomPosition)
  }, _hoisted_5, 4)]), $props.roasData.length > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["roas-text", $options.computedTextClass])
  }, _toDisplayString($options.lastestValue), 3)) : (_openBlock(), _createElementBlock("div", _hoisted_6, "-"))]);
}